// extracted by css-extract-rspack-plugin
export default {"short_game_info_override":"pEFIs","shortGameInfoOverride":"pEFIs","#":"WlUvs","mobile_footer_override":"gB5wy","mobileFooterOverride":"gB5wy"};